import React from "react";

const OnlineBooking: React.FC<any> = (props: any) => {
    return (
        <div className="col-12 pb-2">
                <span className="badge bg-recintesblue pr-3 p-2 closed-acces-badge mb-0 text-white">
                    Reserva online
                </span><br/>
            {(props.venue.availableTicketsCount !== undefined && props.venue.availableTicketsCount !== null) && (
                <small 
                className={
                    props.venue.availableTicketsCount === 0 
                    ? "text-danger" 
                    : "text-success"
                }>
                    {props.venue.availableTicketsCount} {props.venue.currentActivitySession?.unitName ? props.venue.currentActivitySession.unitName : "places"} disponibles
                </small>
            )}
        </div>
    )
};

export default OnlineBooking;